import { useState } from "react";
import { useLocation } from "react-router-dom";
import { Navbar } from "../components/Navbar";
import { Sidebar } from "../components/Sidebar";
import { useGetUserMe } from "../features/user";

export const MainLayout = ({ children }) => {
  const location = useLocation();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const { userMe } = useGetUserMe();

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const noNavbarAndSidebarPages = [
    "/login",
    "/register",
    "/transaction",
    "/hifiair",
  ];
  const shouldShowNavbarAndSidebar = !noNavbarAndSidebarPages.includes(
    location.pathname
  );

  const containerClass =
    userMe?.role === "ADMIN" || userMe?.role === "CS"
      ? "max-w-full"
      : "max-w-lg";

  const contentClass =
    (isSidebarOpen && userMe?.role === "ADMIN") ||
    (isSidebarOpen && userMe?.role === "CS")
      ? "ml-[250px]"
      : "ml-0";
  return (
    <div className="bg-slate-50">
      <div
        className={`relative mx-auto min-h-screen ${containerClass} bg-white shadow-2xl`}
      >
        {shouldShowNavbarAndSidebar && <Navbar toggleSidebar={toggleSidebar} />}

        {shouldShowNavbarAndSidebar && (
          <Sidebar
            isSidebarOpen={isSidebarOpen}
            toggleSidebar={toggleSidebar}
            role={userMe?.role as "ADMIN" | "USER" | "CS"}
          />
        )}

        <div className={`${contentClass} transition-all duration-300`}>
          {children}
        </div>
      </div>
    </div>
  );
};
